<template>
  <div class="child-info">
    <img :src="InfoBanner" class="banner" />
    <!-- 头像 -->
    <div class="head-box">
      <div class="head-img" :class="{ loss_status }">
        <img :src="info.student_gender * 1 === 2 ? Family6 : Family5" />
      </div>
      <div class="grade">
        <span>NO.</span>
        <span class="wechatNumber">{{info.rank}}</span>
      </div>
    </div>
    <!-- 信息 -->
    <div class="text-info">
      <div class="name">{{info.student_name}}</div>
      <div class="phone">{{info.cup_sn}}</div>
      <div class="school">{{info.school}}-{{info.class}}</div>
      <div class="school">建档时间：{{info.create_time}}</div>
    </div>
    <!-- 挂失 -->
    <div class="lose-btn" @click="Loss" v-if="!loss_status && info.is_family * 1 !== 1">挂失</div>
    <div class="lose-btn" @click="$emit('update:choice_open', true)" v-if="loss_status">重新绑定</div>
    <div class="buy-new-btn" v-if="loss_status" @click="OpenPage">购买新水杯</div>
  </div>
</template>

<script>
  import { SetImage } from '@/utils/Image'
  export default {
    data () {
      return {
        // loss_status: false
      }
    },
    methods: {
      Loss () {
        this.$ShowConfirm(
          '1、挂失成功后该水杯编号失效，无法使用。\n2、点击“确认”后需重新录入您的水杯编号，录入成功后可将旧编号信息转到新编号里。\n3、您是否确认要挂失？',
          { messageAlign: 'left' }
        ).then(() => {
          // this.loss_status = true
          this.$Post('Common.CupLoseCup', {
            cup_id: this.$route.query.id
          }).then(res => {
            this.$emit('Refresh')
          })
        })
      },
      OpenPage () {
        window.location.href = this.info.buy_cup_url
      }
    },
    computed: {
      loss_status () {
        return this.info.status * 1 === 2
      },
      ...SetImage(['InfoBanner', ...'1'.repeat(7).split('').map((item, index) => `Family${index + 1}`)])
    },
    props: {
      choice_open: null,
      info: {
        type: Object,
        default: () => ({})
      }
    }
  }
</script>

<style lang="less" scoped>
  .child-info {
    .h(2.74rem);
    box-sizing: border-box;
    .pt(.53rem);
    .pl(.54rem);
    .pr(.48rem);
    position: relative;
    .mb(.7rem);
    .banner {
      .w();
      .h();
      position: absolute;
      top: 0;
      left: 0;
    }
    .head-box {
      .w(1.2rem);
      .mr(.4rem);
      position: relative;
      z-index: 10;
      float: left;
      .flex-ccc();
      .head-img {
        .w(1.2rem);
        .h(1.2rem);
        .br(.6rem);
        overflow: hidden;
        position: relative;
        img {
          .h();
          .w();
        }
        &.loss_status {
          &::after {
            content: '已挂失';
            position: absolute;
            .w();
            .h();
            .br(inherit);
            top: 0;
            left: 0;
            z-index: 10;
            .c(#fff);
            .flex-cc();
            .bg(rgba(0, 0, 0, .3));
          }
        }
      }
      .grade {
        .mt(-.13rem);
        .p(.05rem .2rem .06rem);
        box-sizing: border-box;
        .br(.3rem);
        .bg(#ffc000);
        .c(#fff);
        .fz(.2rem);
        z-index: 10;
        .wechatNumber {
          .fz(.32rem);
        }
      }
    }
    .text-info {
      float: left;
      position: relative;
      z-index: 10;
      .c(#fff);
      .pt(.12rem);
      .name {
        .fz(.3rem);
        .c(#fff);
        font-weight: bold;
        .mb(.12rem);
      }
      .phone {
        .fz(.26rem);
        .mb(.23rem);
      }
      .school {
        .fz(.24rem);
        .mb(.1rem);
      }
    }
    .lose-btn {
      float: right;
      z-index: 10;
      position: relative;
      .p(0.03rem .18rem 0);
      .h(.34rem);
      .lh(.34rem);
      box-sizing: border-box;
      .br(.17rem);
      .bg(#fff);
      .fz(.2rem);
      .c(#ff2c4c);
      top: .09rem;
    }
    .buy-new-btn {
      .bg(#007dd5);
      .h(.4rem);
      .br(.2rem);
      .p(0 .13rem);
      .lh(.4rem);
      .c(#fff);
      .fz(.2rem);
      position: absolute;
      top: 1.4rem;
      right: .48rem;
    }
  }
</style>
